const status = status => {
  return status === 'active' ? 'Ativo' : 'Inativo'
}

export default status
